<template>
	<div class="VisibleView" :class="modes.map((m) => `VisibleView--${m}`)">
		<div class="VisibleViewButton" @click="$emit('click', $event)" v-if="to">
			<svg-view name="visible-icon" />
		</div>
		<div class="VisibleViewButton" @click="$emit('click', $event)" v-else>
			<svg-view name="not-visible-icon" />
		</div>
	</div>
</template>

<script>
export default {
	name: "VisibleView",
	props: {
		to: { type: Boolean, default: false },
		modes: { type: Array, default: () => [] },
	},
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .VisibleView;

@{r} {
	position: absolute;
	top: 6px;
	right: 31px;
	z-index: 10;

	svg {
		width: 10px;
		height: 8px;
		display: block;
		transition: fill 0.2s;
		fill: @color-black;
	}

	&:hover {
		opacity: 0.7;
	}

	&Button {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: @color-white;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 1px solid @color-black;
		cursor: pointer;
	}

	&--stores {
		top: 30px;
		right: -30px;
	}

	&--noBorder {
		border: none;
	}
}
</style>
